import * as tslib_1 from "tslib";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ChangeParamsButton from "@/components/ChangeParamsButton.vue";
import ContactDetailsModal from "@/components/ContactDetailsModal.vue";
import SortOffersSelect from "@/components/SortOffersSelect.vue";
import OffersTable from "@/components/OffersTable.vue";
const cashSimulationModule = namespace("cashSimulation");
let SearchResults = class SearchResults extends Vue {
    constructor() {
        super(...arguments);
        this.contactDetailsModal = true;
        this.isBlurred = true;
        this.offers = [];
        this.sort = "installment";
        this.compareLength = 0;
    }
    onSimulationChange(name) {
        this.offers = this.getOffers();
    }
    closeContactDetailsModal() {
        this.contactDetailsModal = false;
        this.isBlurred = false;
    }
    getOffers() {
        return this.getSimulation.data.simulation.offers;
    }
    setCompareLength(offers) {
        this.compareLength = offers.length;
    }
};
tslib_1.__decorate([
    cashSimulationModule.Getter("getSimulation")
], SearchResults.prototype, "getSimulation", void 0);
tslib_1.__decorate([
    Watch("getSimulation", { immediate: true, deep: true })
], SearchResults.prototype, "onSimulationChange", null);
SearchResults = tslib_1.__decorate([
    Component({
        components: {
            OffersTable,
            ContactDetailsModal,
            ChangeParamsButton,
            SortOffersSelect
        }
    })
], SearchResults);
export default SearchResults;
